module.exports = __webpack_public_path__ + "static/media/Logo.fc708b59.png";